export const dashboardConstants = {
    DASHBOARD_STATS_REQUEST: 'DASHBOARD_STATS_REQUEST',
    DASHBOARD_STATS_SUCCESS: 'DASHBOARD_STATS_SUCCESS',
    DASHBOARD_STATS_FAILURE: 'DASHBOARD_STATS_FAILURE'
};
